export default "__VITE_PUBLIC_ASSET__578bd1b2__"